import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Button, IconButton, Link } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import { post, put } from "../../../../utils/api";
import axios from "axios";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";
import { categoryData } from "./categoryData";

const LCA_AUTOFETCH_SUGGEST_URL =
  "https://lca-dev-api-in.mykarb.com/api/lca/vajra/autofetch/categories/suggest";

const toTitleCaseWords = (input) => {
  const s = String(input || "").trim();
  if (!s) return "";
  return s
    .split(/\s+/)
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ""))
    .join(" ");
};

function AddData({
  inputData,
  fetchData,
  id,
  title,
  element,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  uniqueValues,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});

  const initialState = {
    consumptionPeriod: {
      month: element?.consumptionPeriod?.month || "",
      year: element?.consumptionPeriod?.year || "",
    },
    purchaseVendor: element?.purchaseVendor._id || "",
    categoryType: element?.categoryType || "",
    activityName: element?.activityName || "",
    typeOfActivity: element?.typeOfActivity || "",
    amountSpend: element?.amountSpend || { value: "" },
    quantityBought: {
      value: element?.quantityBought?.value || "",
      unit: element?.quantityBought?.unit || "",
    },
    remark: element?.remark || "",
    documents: element?.documents || [],
    editRemarkReason: element?.editRemarkReason || "",
  };

  const [formData, setFormData] = useState(initialState);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [newOptions, setNewOptions] = useState([]);
  const [activityNameSuggestLoading, setActivityNameSuggestLoading] =
    useState(false);
  /** After a successful LCA fetch, link switches to "Manual entry" to clear type + category. */
  const [lcaCategorySuggestMode, setLcaCategorySuggestMode] = useState("auto");
  const [categoryTypeOptions, setCategoryTypeOptions] = useState(categoryData);
  const drawerWasOpenRef = useRef(false);

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(element?.documents || []);
    setLcaCategorySuggestMode("auto");
    setCategoryTypeOptions(categoryData);
  }, [element, id]);

  useEffect(() => {
    if (addData && !drawerWasOpenRef.current) {
      setLcaCategorySuggestMode("auto");
      setCategoryTypeOptions(categoryData);
    }
    drawerWasOpenRef.current = addData;
  }, [addData]);

  useEffect(() => {
    setNewOptions([
      ...new Set([
        ...(Array.isArray(uniqueValues?.typeOfActivity)
          ? uniqueValues?.typeOfActivity
          : []),
        "Production Materials",
        "Finished Goods",
        "Transportation and Distribution (not included in Upstream and Downstream Transportation and Distribution category)",
        "Information Technology and Communication",
        "Professional Services",
        "Others",
      ]),
    ]);
  }, [uniqueValues?.typeOfActivity]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

    if (name.startsWith("quantityBought")) {
      const [field, key] = name.split(".");
      console.log(field, key);

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else if (name === "amountSpend")
      setFormData((prevState) => ({
        ...prevState,
        [name]: { ...prevState[name], value: value },
      }));
    else setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(element?.documents || []); // Reset uploaded files
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key],
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  // const handleClose = () => {
  //   setAddData(false);
  //   setErrors({});
  //   setFormData(initialState);
  //   setUploadedFiles(element?.documents || []); // Populate with existing documents
  // };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      console.log(input.fieldName, value);
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      // Handle specific field validations
      if (input.fieldName === "amountSpend") {
        if (value?.value === "") {
          newErrors[input.fieldName] = `${input.title} is required.`;
        } else if (!validateNumber(value.value)) {
          newErrors[input.fieldName] = numberError;
        }
        return;
      }

      if (
        input?.fieldName === "typeOfActivity" &&
        formData?.typeOfActivity === "Others"
      )
        newErrors[input?.fieldName] = `${input.title} is required.`;

      // if (input?.fieldName === "quantityBought" && value?.value !== "") {
      //   if (!newErrors[input.fieldName]) {
      //     newErrors[input.fieldName] = {}; // Ensure the object exists
      //   }
      //   if (!validateNumber(value?.value)) {
      //     newErrors[input.fieldName].value = numberError;
      //     if (value?.unit === "") {
      //       newErrors[input.fieldName].value = "Unit is required.";
      //     }
      //   }
      // }

      if (input.fieldName === "quantityBought") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (cvValue === "" && cvUnit === "") return;
        if (cvValue === "" || !validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value is required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }

      // Handle required fields
      if (input.required && value === "") {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
      //   newErrors[input.fieldName] = "Please upload Documents";
      // }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;
    console.log(uploadedFiles);

    let dataToSend = { ...formData, documents: uploadedFiles };

    if (
      element &&
      id &&
      element?.typeOfActivity !== formData?.typeOfActivity &&
      inputData.some(
        (el) =>
          el.fieldName === "typeOfActivity" &&
          el.options.includes(element?.typeOfActivity),
      ) === false
    ) {
      dataToSend = { ...formData, prevTypeOfActivity: element.typeOfActivity };
    }

    // Remove empty fields
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     dataToSend[key] === "" ||
    //     (typeof dataToSend[key] === "object" &&
    //       Object.keys(dataToSend[key]).length === 0)
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;
    let method = id ? put : post;

    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 1 }}>
          <MonthYearPicker
            {...{
              name: el.fieldName,
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              title: el.title,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    if (el.fieldName === "categoryType") {
      return (
        <Box>
          <AutoComplete
            title={formatTitleWithOptional(el.title)}
            name={el.fieldName}
            handleChange={handleChange}
            value={formData[el.fieldName]}
            options={categoryTypeOptions}
            errors={errors[el.fieldName]}
          />
          {el.autoFetchLabel && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={async () => {
                  if (lcaCategorySuggestMode === "manual") {
                    setFormData((prev) => ({
                      ...prev,
                      typeOfActivity: "",
                      categoryType: "",
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      typeOfActivity: "",
                      categoryType: "",
                    }));
                    setLcaCategorySuggestMode("auto");
                    setCategoryTypeOptions(categoryData);
                    return;
                  }

                  const activityNameForApi =
                    (formData?.activityName || "").trim() ||
                    (formData?.typeOfActivity || "").trim();
                  if (!activityNameForApi) {
                    setsnackOpen({
                      open: true,
                      message:
                        "Enter activity name first, then try auto-fetch.",
                      severity: "warning",
                    });
                    return;
                  }
                  setActivityNameSuggestLoading(true);
                  try {
                    const body = {
                      activityName: activityNameForApi,
                      productDescription: (formData?.remark || "").trim(),
                      limit: 10,
                    };
                    const token = sessionStorage.getItem("token");
                    const { data: res } = await axios.post(
                      LCA_AUTOFETCH_SUGGEST_URL,
                      body,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          ...(token
                            ? { Authorization: `Bearer ${token}` }
                            : {}),
                        },
                      },
                    );
                    const top =
                      Array.isArray(res?.results) && res.results.length > 0
                        ? res.results[0]
                        : null;
                    const categoryTypeRaw =
                      top?.categoryType && String(top.categoryType).trim();
                    const categoryType = toTitleCaseWords(categoryTypeRaw);
                    if (!categoryType) {
                      setsnackOpen({
                        open: true,
                        message:
                          "No category suggestion returned. Pick category manually.",
                        severity: "info",
                      });
                      return;
                    }
                    const suggested = Array.isArray(res?.results)
                      ? res.results
                          .map((r) => toTitleCaseWords(r?.categoryType))
                          .filter(Boolean)
                      : [];
                    const uniqueSuggested = Array.from(new Set(suggested));
                    if (uniqueSuggested.length > 0) {
                      setCategoryTypeOptions(uniqueSuggested);
                    }
                    const cleaned = (res?.cleanedProductPhrase || "").trim();
                    setFormData((prev) => ({
                      ...prev,
                      ...(cleaned ? { activityName: cleaned } : {}),
                      categoryType,
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      activityName: "",
                      categoryType: "",
                    }));
                    setLcaCategorySuggestMode("manual");
                  } catch (e) {
                    console.error(e);
                    const msg =
                      e?.response?.data?.message ||
                      (typeof e?.response?.data === "string"
                        ? e.response.data
                        : null) ||
                      e?.message ||
                      "Could not fetch category suggestion.";
                    setsnackOpen({
                      open: true,
                      message: msg,
                      severity: "error",
                    });
                  } finally {
                    setActivityNameSuggestLoading(false);
                  }
                }}
                disabled={activityNameSuggestLoading}
                sx={{
                  cursor: activityNameSuggestLoading ? "default" : "pointer",
                  fontSize: "0.875rem",
                  textDecoration: "underline",
                }}
              >
                {activityNameSuggestLoading
                  ? "Fetching…"
                  : lcaCategorySuggestMode === "manual"
                    ? "Manual entry"
                    : el.autoFetchLabel}
              </Link>
            </Box>
          )}
        </Box>
      );
    }

    if (el.fieldName === "activityName") {
      return (
        <Box>
          <InputField
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName] || ""}
            fieldName={el.fieldName}
          />
        </Box>
      );
    }

    if (el.fieldName === "typeOfActivity") {
      return (
        <AutoComplete
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          handleChange={handleChange}
          value={formData[el.fieldName]}
          options={newOptions}
          errors={errors[el.fieldName]}
          disableTyping={true}
        />
      );
    }

    if (el.fieldName === "quantityBought") {
      return (
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box sx={{ width: "65%" }}>
            <InputField
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData[el.fieldName]?.value || ""}
              errors={errors[el.fieldName]?.value} // Access error for value
              fieldName={`${el.fieldName}.value`}
            />
          </Box>
          <Box sx={{ width: "35%", mt: "9%" }}>
            <SelectField
              name={`${el.fieldName}.unit`}
              value={formData[el.fieldName]?.unit}
              handleChange={handleChange}
              options={el.options}
              errors={errors[el.fieldName]?.unit} // Access error for unit
              field={`${el.field}.unit`}
              defaultValue="Unit"
            />
          </Box>
        </Box>
      );
    }

    if (el.type === "select" || el.options) {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          url={el.url}
          errors={errors[el.fieldName]}
          field={el.field}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remark") {
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    }

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.nested ? formData[el.fieldName]?.value : formData[el.fieldName]
        }
        errors={errors[el.fieldName] || ""}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title} Data` : `Add ${title} Data`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddData;
